<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">Open Conditions</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="headers" :items="patient_data" :search="search">
      <template v-slot:no-data> No Open Conditions </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HCC',
  props: ['patient', 'insurance', 'recordLimit'],

  data() {
    return {
      search: '',
      loading: false,
      headers: [
        { text: 'Patient', value: 'PATIENT_NAME' },
        { text: 'DOB', value: 'DOB' },
        { text: 'Provider', value: 'PCP_NAME' },
        { text: 'Servicer', value: 'GROUP_NAME' },
        { text: 'Date', value: 'CLAIM_DATE' },
        { text: 'Code', value: 'CODE' },
        { text: 'HCC Category', value: 'HCC_CATEGORY' },
        { text: 'HCC Description', value: 'HCC_DESCIRPTION' },
      ],
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async getClaims() {
      this.loading = true;

      const startDate = new Date(new Date().getFullYear(), 0, 1).toISOString().substring(0, 7);
      const endDate = new Date(new Date().getFullYear(), 11, 31).toISOString().substring(0, 7);

      const response = await axios
        .get(
          `/api/coding/openconditions/orgs=/groups=/providers=/locs=/${this.patient}/${this.insurance}/${startDate}/${endDate}/`
        )
        .then((response) => {
          this.patient_data = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
